module.exports = __webpack_public_path__ + "img/第2档.1aaf5f7d.png";